<template>
  <div>
    <div
      v-if="!listDatasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <a-table
      v-else
      :columns="columns"
      :data-source="data"
      :row-class-name="rowItem"
      :pagination="false"
      class="table-list relate-table"
    >
      <div
        slot="assign_rule_str"
        slot-scope="assign_rule_str, record"
        class="develop-td"
      >
        <!-- <span>{{ assign_rule_str }}</span> -->
        <i
          v-if="!record.status"
          class="iconfont iconshixiao"
        /><RuleTooptip :text="assign_rule_str" />
      </div>
      <div
        slot="assign_user_str"
        slot-scope="assign_user_str"
        class="assign-user-list"
      >
        <div v-html="assign_user_str" />
      </div>
      <div
        slot="method"
        slot-scope="text"
      >
        <div class="">
          {{ text }}
        </div>
      </div>
      <div
        slot="setruleid"
        slot-scope="text, record"
      >
        <div class="alloc-op-tool-box">
          <a
            href="javascript:;"
            @click="editItem(record)"
          >{{ $t('message["36"]') }}</a>
          <a
            href="javascript:;"
            @click="delItem(record)"
          >{{ $t('message["962"]') }}</a>
        </div>
      </div>
      <div
        slot="setmethodid"
        slot-scope="text, record"
      >
        <div class="alloc-op-tool-box">
          <a
            href="javascript:;"
            @click="editMethod(record)"
          >{{ $t('message["36"]') }}</a>
        </div>
      </div>
    </a-table>
    <all-tip-modal
      ref="tipModal"
      :type="tipType"
      :item-data="itemData"
    />
    <add-alloca-dialog
      ref="addAllocaDialog"
      :item-data="item"
      type="edit"
    />
    <edit-method-dia
      ref="editmethod"
      :item-data="item"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AllTipModal from '@/components/pc/config/allocationrule/AllTipModal'
import AddAllocaDialog from '@/components/pc/config/allocationrule/AddAllocaDialog'
import RuleTooptip from './RuleTooptip'
import EditMethodDia from '@/components/pc/config/allocationrule/EditMethodDia'
export default {
  components: {
    AllTipModal,
    AddAllocaDialog,
    RuleTooptip,
    EditMethodDia
  },
  props: {
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tipType: 'del',
      itemData: {},
      item: {}
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['listDatas', 'listDatasReady', 'DatasReady']),
    ...mapGetters('config/allocationrule', ['editSelectedDatas'])
  },
  async mounted () {
  },
  methods: {
    ...mapActions('config/allocationrule', ['delAllocation', 'getGroupMembers', 'delAllocation']),
    rowItem (record, index) {
      return !record.status ? 'del-row-item' : ''
    },
    editItem (item) {
      this.item = item
      const itemData = item
      const { editSelectedDatas } = this
      editSelectedDatas.forEach(item => {
        if (Object.keys(item).indexOf('defaultValue') > -1) {
          delete item.defaultValue
        }
        if (Object.keys(item).indexOf('fieldvalue') > -1) {
          delete item.fieldvalue
        }
      })
      if (itemData['assign_rule']) {
        for (let key in itemData['assign_rule']) {
          editSelectedDatas.forEach(item2 => {
            // if (Object.keys(item).indexOf('defaultValue') > -1) {
            //   delete item.fieldValue
            // }
            if (key === item2.fieldkey) {
              item2.defaultValue = itemData['assign_rule'][key]
              if (item2.fieldtype === 'area') {
                item2.fieldvalue = itemData['assign_rule'][key]
                // this.$set(item2, 'fieldvalue', itemData['assign_rule'][key])
              }
            }
          })
        }
      }
      this.$refs.addAllocaDialog.changeVisible(true)
    },
    async delItem (item) {
      this.itemData = item
      if (!item.status) {
        const chain = await this.delAllocation()
        chain.params({ id: item.id })
          .onSuccess(raw => {
            this.$message.success(this.$t('message["965"]') + '！')
            this.TipDialogVisible = false
          })
          .fetch()
      } else {
        this.$refs.tipModal.changeLimitDialog(true)
      }
    },
    async editMethod (item) {
      const chain = await this.getGroupMembers()
      chain.params({ groupid: item.groupid })
        .onSuccess(raw => {
          this.item = raw
          this.$refs.editmethod.changeVisible(true)
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .relate-table::v-deep  {
    td {
      vertical-align: middle
    }
  }
  .alloc-op-tool-box {
    a{
      margin-right: 16px;
    }
  }
  .develop-td {
    width:500px;
    height: 24px;
    line-height: 24px;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .assign-user-list::v-deep span {
    color: #999;
    font-size: 12px;
  }
  .iconshixiao {
    font-size: 26px;
    margin-right: -26px;
  }
</style>
